<script>

export default {
  data() {
    return {
      saved: localStorage.getItem('roster') ? true : false
    }
  },
}
</script>

<template>
  <template v-if="saved">
    <h3>Ростер сохранен</h3>
    <p>Но что бы он сохранился в Вашей коллекции, пожалуйста, войдите в систему или создайте аккаунт.</p>
  </template>
</template>
